import { TextField as MuiTextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ChangeEvent } from 'react';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import type { FieldComponentProps } from '../form-engine/types';
import type { DateValue } from '../../types';

const ArrayField = ({
  field,
  getYearlyDaysFromDate,
}: FieldComponentProps & { getYearlyDaysFromDate: (yearly_days: DateValue[]) => string[] }) => {
  const { getFormDataItem, handleChange } = useFormContext();
  const formData = useFormData();

  return (
    <Grid size={field.size || 12} key={field.name}>
      <MuiTextField
        label={field.label}
        fullWidth
        required={field.required || false}
        disabled={Object.prototype.hasOwnProperty.call(field, 'disabled') ? !!getFormDataItem(formData, field.disabled!) : false}
        type={field.type}
        name={field.name}
        value={
          getFormDataItem<DateValue[]>(formData, field.name!)
            ? getYearlyDaysFromDate(getFormDataItem<DateValue[]>(formData, field.name!))
            : []
        }
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          handleChange({ target: { name: e.target.name, value: e.target.value, type: field.type, checked: e.target.checked } }, field)
        }
      />
    </Grid>
  );
};

export default ArrayField;
